export const ROOT = '/'
export const ABOUT_PAGE = '/o-me-cinnosti'
export const SESSION_PAGE = '/prubeh-sezeni'
export const PRICE_PAGE = '/cenik'
export const FOTO_PAGE = '/foto'
export const CONTACT_PAGE = '/kontakt'
